import React, { ReactNode, ErrorInfo, useState } from "react";
import ErrorPage from "./features/error";

interface ErrorBoundaryProps {
  children: ReactNode;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const [hasError, setHasError] = useState(false);

  const getDerivedStateFromError = (): void => {
    // Update state to display the fallback UI
    setHasError(true);
  };

  const componentDidCatch = (error: Error, info: ErrorInfo): void => {
    // Log error information, e.g., send it to a logging service
    console.error("Error Boundary caught an error:", error, info);
  };

  if (hasError) {
    return <ErrorPage />;
  }

  return <>{children}</>;
};

export default ErrorBoundary;
